import { List } from 'immutable';
import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, dividendId, type, data) {
    return {
        type: 'MARKETS_UPDATE_DIVIDEND_REQUEST',
        dividendType: type,
        eventId,
        marketId,
        dividendId,
        data
    };
}

export function error(marketId, dividendId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_UPDATE_DIVIDEND_ERROR',
        errors,
        marketId,
        dividendId
    };
}

export function finish(marketId, dividendId, market) {
    return (dispatch) => {
        dispatch(bulkSelections(market.selections));

        market.selections = market.selections.map(x => x.id);

        dispatch({
            type: 'MARKETS_UPDATE_DIVIDEND_FINISH',
            market,
            marketId,
            dividendId
        });
    };
}
